import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";

const AppInfo = () => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <div className="min-h-screen  bg-neutral-50">
        <div className="flex justify-between items-center mx-[20px] pt-5">
          <div className="flex-[0.3]">
            <button
              className="h-10 text-neutral-300 flex justify-center items-center"
              onClick={() => navigate(-1)}
            >
              <ChevronLeftIcon className="h-6 w-6 font-bold" />
            </button>
          </div>
          <div className="flex-[0.7]">
            <h4 className="text-header-4">App Info</h4>
          </div>
        </div>
        <div className="flex-1 flex-col justify-center items-center flex mt-[180px]">
          {/* <div className="rounded-[16px] w-[53px] h-[53px] flex justify-center items-center bg-primary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="43"
                height="25"
                viewBox="0 0 43 25"
                fill="none"
              >
                <g clip-path="url(#clip0_1280_5363)">
                  <path
                    d="M11.2882 17.6899C8.95379 20.1873 6.69211 22.6055 4.456 24.9982C3.17707 23.6376 1.93988 22.3195 0.636719 20.9334C1.15502 20.3841 1.74467 19.7555 2.33971 19.1297C6.77961 14.4619 11.2074 9.78127 15.6742 5.14032C16.3137 4.47631 16.6314 3.83213 16.5749 2.87081C16.4941 1.48192 17.2439 0.489453 18.5013 0.108606C18.7315 0.0392322 18.9819 0.0236585 19.2243 0.0236585C21.4456 0.0179954 23.6682 0.0647164 25.8868 0.00100593C27.0338 -0.0315572 27.9587 0.335132 28.6708 1.24124C29.0734 1.75375 29.5513 1.88825 30.1409 1.88401C32.3178 1.86843 34.4933 1.89392 36.6702 1.86843C37.4173 1.85994 38.0245 2.12327 38.5401 2.65844C39.7665 3.93548 40.9903 5.21677 42.2059 6.50656C42.77 7.10402 42.7821 7.54858 42.2275 8.1517C41.4803 8.96578 40.7183 9.76712 39.9389 10.5486C39.3613 11.1277 38.8861 11.0965 38.3139 10.4991C37.455 9.60005 36.6204 8.67696 35.7319 7.81191C35.4815 7.5684 35.0816 7.37585 34.7451 7.36736C33.0865 7.32205 31.4252 7.34329 29.7653 7.34895C29.0276 7.35178 28.6399 7.68166 28.7153 8.46742C28.8647 10.0177 28.1821 11.0838 27.1873 12.1117C23.959 15.4473 20.7792 18.8338 17.5792 22.2006C16.7526 23.0699 16.3783 23.0769 15.5638 22.2204C14.1705 20.7536 12.7852 19.2784 11.2868 17.6899H11.2882ZM10.4629 16.0391C11.5668 14.8795 12.6277 13.7653 13.6885 12.6511C15.195 11.0682 16.7001 9.48396 18.2092 7.90394C18.9483 7.13092 19.2754 7.13092 20.001 7.88553C20.1451 8.03419 20.2851 8.1871 20.4305 8.33434C21.7431 9.67792 23.057 11.0215 24.4275 12.4231C24.9848 11.8186 25.4762 11.1971 26.0537 10.6817C26.7255 10.0814 26.9692 9.40184 26.9436 8.47025C26.8965 6.70618 28.0906 5.51126 29.7586 5.50701C31.3512 5.50276 32.9438 5.53957 34.535 5.49427C35.5986 5.46454 36.4413 5.84538 37.1616 6.64955C37.7997 7.36169 38.4822 8.02994 39.0759 8.64581C39.5875 8.16869 40.0304 7.75387 40.4895 7.3263C39.5229 6.30976 38.5805 5.36543 37.6933 4.3673C37.2275 3.84346 36.7321 3.62118 36.0442 3.63675C34.0935 3.67923 32.1401 3.59853 30.1907 3.67073C28.9966 3.71462 28.0408 3.34935 27.2829 2.39794C26.953 1.98453 26.5505 1.85994 26.0389 1.86702C24.0653 1.89533 22.0917 1.87834 20.1182 1.87834C18.3317 1.87834 18.298 1.87834 18.3465 3.73444C18.368 4.58108 18.1217 5.21252 17.5468 5.79866C15.8896 7.48911 14.2768 9.22629 12.6358 10.9337C11.4618 12.1556 10.2718 13.359 9.07226 14.5893C9.58652 15.1245 9.99713 15.552 10.4643 16.0391H10.4629ZM22.4458 14.333C21.5842 14.1731 20.7805 13.9734 19.966 13.8998C19.6618 13.8729 19.2673 14.0612 19.0291 14.2863C18.2967 14.9801 17.6222 15.7389 16.9208 16.4695C16.4187 16.9919 15.9125 17.5086 15.475 17.9589C15.0092 17.5313 14.608 17.1618 14.1785 16.7668C15.514 15.3524 16.7687 13.9423 18.1136 12.6355C18.6925 12.0734 19.4827 11.8823 20.3147 12.0975C20.7442 12.2094 21.1952 12.2306 21.5371 12.2801C20.7374 11.4208 19.9162 10.5387 19.1718 9.74022C17.011 11.9984 14.8261 14.2821 12.6802 16.5247C13.9537 17.8725 15.2434 19.2387 16.5062 20.5752C18.4569 18.5238 20.417 16.4638 22.4445 14.333H22.4458ZM7.89161 16.083C6.28958 17.7578 4.69159 19.427 3.14342 21.0453C3.51633 21.5012 3.90404 21.9755 4.25676 22.4087C5.89917 20.6828 7.49177 19.0108 9.12342 17.2963C8.72493 16.9055 8.30356 16.4907 7.89026 16.0844L7.89161 16.083Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1280_5363">
                    <rect
                      width="42"
                      height="25"
                      fill="white"
                      transform="translate(0.636719)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div> */}
          <img src="/oak fuel.png" alt="info" />
          <div className="text-center text-[#484442] mt-6">version 1.0</div>

          {/* <div className='text-center text-neutral-300 text-[24px] font-semibold mt-3'>
            OYA Fuel
          </div> */}
        </div>
      </div>
    </Fragment>
  );
};

export default AppInfo;
